import {baseNewImagesPath} from "../../assets";

export const applianceThumbnail    = `${baseNewImagesPath}images/kv-icons/kv-filter-icons-stove.svg`;
export const centerIslandThumbnail    = `${baseNewImagesPath}images/kv-icons/center_island_countertop.svg`;
export const countertopGroupThumbnail    = `${baseNewImagesPath}images/kv-icons/vanity-countertop.svg`;
export const wallsThumbnail    = `${baseNewImagesPath}images/bv_icons_new/Icons_Wall.svg`;

/*layouts*/
export const LayoutThumbnails = {
  Layout1: `${baseNewImagesPath}images/kv-layout-thumbnails/SI.png`,
  Layout2: `${baseNewImagesPath}images/kv-layout-thumbnails/SNI.png`,
  Layout3: "Layout3",
  Layout4: "Layout4",
  Layout5: "Layout5",
  Layout6: "Layout6",
  Layout7: "Layout7",
  Layout8: "Layout8",
  Layout9: "Layout9",
  Layout10: "Layout10",
  Layout11: "Layout11",
  Layout12: "Layout12",
  Layout13: "Layout13",
  Layout14: "Layout14",
  Layout15: "Layout15",
  Layout16: "Layout16",
  Layout17: "Layout17",
  Layout18: "Layout18",
};
